const normalizeBaseUrl = (value) => {
  if (!value) return '';
  return value.replace(/\/+$/, '');
};

const resolveApiBaseUrl = () => {
  const envBase = normalizeBaseUrl(process.env.REACT_APP_API_URL);
  if (envBase) return envBase;

  if (typeof window === 'undefined') return '';

  const { hostname, origin } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5000';
  }

  return `${origin}/api`;
};

export const API_BASE_URL = resolveApiBaseUrl();

export const withApiBase = (path = '') => {
  if (!path) return API_BASE_URL;
  if (!API_BASE_URL) return path;
  return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

export const buildImageUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  if (!API_BASE_URL) return path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};
